module.exports = __webpack_public_path__ + "img/bg.c5ee99b6.png";